import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faSearch, faTrash, faTruck } from "@fortawesome/free-solid-svg-icons";

export default function MahilaMandiWholesale() {
  const [pinCode, setPinCode] = useState("");
  const [neighbourhood, setNeighbourhood] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [basketPrepared, setBasketPrepared] = useState(false);
  const [basketItems, setBasketItems] = useState([]);
  const [cart, setCart] = useState([]);
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [orderDetails, setOrderDetails] = useState({ name: "", address: "", pin: "", mobile: "", email: "" });
  const [orderPlaced, setOrderPlaced] = useState(false);

  const categories = [
    { name: "Pickles & Preserves", img: "🥒" },
    { name: "Handmade Soaps", img: "🧼" },
    { name: "Baked Goods", img: "🍪" },
    { name: "Herbal Teas", img: "☕" },
    { name: "Textiles", img: "🧵" },
    { name: "Jewelry", img: "💍" },
    { name: "Candles", img: "🕯️" },
    { name: "Pottery", img: "🏺" },
    { name: "Handicrafts", img: "🪡" },
  ];

  const dummyItems = {
    "Pickles & Preserves": [
      { name: "Mango Pickle", unit: "bulk jar (5kg)", marketPrice: 750, wholesalePrice: 650, img: "https://via.placeholder.com/80?text=Mango+Pickle" },
      { name: "Lemon Pickle", unit: "bulk jar (5kg)", marketPrice: 600, wholesalePrice: 500, img: "https://via.placeholder.com/80?text=Lemon+Pickle" },
      { name: "Garlic Pickle", unit: "bulk jar (5kg)", marketPrice: 550, wholesalePrice: 450, img: "https://via.placeholder.com/80?text=Garlic+Pickle" },
      { name: "Mixed Fruit Jam", unit: "bulk jar (5kg)", marketPrice: 900, wholesalePrice: 800, img: "https://via.placeholder.com/80?text=Fruit+Jam" },
      { name: "Chili Pickle", unit: "bulk jar (5kg)", marketPrice: 700, wholesalePrice: 600, img: "https://via.placeholder.com/80?text=Chili+Pickle" },
      { name: "Amla Pickle", unit: "bulk jar (5kg)", marketPrice: 650, wholesalePrice: 550, img: "https://via.placeholder.com/80?text=Amla+Pickle" },
    ],
    "Handmade Soaps": [
      { name: "Lavender Soap", unit: "box (50 bars)", marketPrice: 4000, wholesalePrice: 3500, img: "https://via.placeholder.com/80?text=Lavender+Soap" },
      { name: "Rose Soap", unit: "box (50 bars)", marketPrice: 4500, wholesalePrice: 4000, img: "https://via.placeholder.com/80?text=Rose+Soap" },
      { name: "Cinnamon Soap", unit: "box (50 bars)", marketPrice: 4750, wholesalePrice: 4250, img: "https://via.placeholder.com/80?text=Cinnamon+Soap" },
      { name: "Aloe Vera Soap", unit: "box (50 bars)", marketPrice: 4250, wholesalePrice: 3750, img: "https://via.placeholder.com/80?text=Aloe+Soap" },
      { name: "Neem Soap", unit: "box (50 bars)", marketPrice: 4750, wholesalePrice: 4250, img: "https://via.placeholder.com/80?text=Neem+Soap" },
      { name: "Sandalwood Soap", unit: "box (50 bars)", marketPrice: 5000, wholesalePrice: 4500, img: "https://via.placeholder.com/80?text=Sandalwood+Soap" },
    ],
    "Baked Goods": [
      { name: "Oatmeal Cookies", unit: "bulk pack (10 packs)", marketPrice: 1800, wholesalePrice: 1600, img: "https://via.placeholder.com/80?text=Oatmeal+Cookies" },
      { name: "Brownies", unit: "bulk pack (10 packs)", marketPrice: 1600, wholesalePrice: 1400, img: "https://via.placeholder.com/80?text=Brownies" },
      { name: "Besan Ladoo", unit: "bulk pack (10 packs)", marketPrice: 2000, wholesalePrice: 1800, img: "https://via.placeholder.com/80?text=Besan+Ladoo" },
      { name: "Gingerbread", unit: "bulk pack (10 packs)", marketPrice: 1900, wholesalePrice: 1700, img: "https://via.placeholder.com/80?text=Gingerbread" },
      { name: "Rusk", unit: "bulk pack (10 packs)", marketPrice: 1200, wholesalePrice: 1000, img: "https://via.placeholder.com/80?text=Rusk" },
      { name: "Plum Cake", unit: "bulk pack (10 units)", marketPrice: 2500, wholesalePrice: 2200, img: "https://via.placeholder.com/80?text=Plum+Cake" },
    ],
    "Herbal Teas": [
      { name: "Herbal Blend", unit: "bulk pack (20 packs)", marketPrice: 4500, wholesalePrice: 4000, img: "https://via.placeholder.com/80?text=Herbal+Tea" },
      { name: "Chamomile Tea", unit: "bulk pack (20 packs)", marketPrice: 4000, wholesalePrice: 3500, img: "https://via.placeholder.com/80?text=Chamomile" },
      { name: "Masala Chai", unit: "bulk pack (20 packs)", marketPrice: 4400, wholesalePrice: 3900, img: "https://via.placeholder.com/80?text=Masala+Chai" },
      { name: "Hibiscus Tea", unit: "bulk pack (20 packs)", marketPrice: 4200, wholesalePrice: 3700, img: "https://via.placeholder.com/80?text=Hibiscus" },
      { name: "Tulsi Tea", unit: "bulk pack (20 packs)", marketPrice: 3800, wholesalePrice: 3300, img: "https://via.placeholder.com/80?text=Tulsi+Tea" },
      { name: "Green Tea Blend", unit: "bulk pack (20 packs)", marketPrice: 4600, wholesalePrice: 4100, img: "https://via.placeholder.com/80?text=Green+Tea" },
    ],
    "Textiles": [
      { name: "Cotton Scarf", unit: "bulk (20 pcs)", marketPrice: 6000, wholesalePrice: 5500, img: "https://via.placeholder.com/80?text=Cotton+Scarf" },
      { name: "Handkerchief", unit: "bulk (50 pcs)", marketPrice: 4500, wholesalePrice: 4000, img: "https://via.placeholder.com/80?text=Handkerchief" },
      { name: "Woolen Shawl", unit: "bulk (10 pcs)", marketPrice: 4000, wholesalePrice: 3500, img: "https://via.placeholder.com/80?text=Woolen+Shawl" },
      { name: "Kurta Fabric", unit: "bulk (50m)", marketPrice: 14000, wholesalePrice: 13000, img: "https://via.placeholder.com/80?text=Kurta+Fabric" },
      { name: "Embroidered Dupatta", unit: "bulk (15 pcs)", marketPrice: 6000, wholesalePrice: 5500, img: "https://via.placeholder.com/80?text=Embroidered+Dupatta" },
      { name: "Saree Blouse Piece", unit: "bulk (20 pcs)", marketPrice: 8000, wholesalePrice: 7500, img: "https://via.placeholder.com/80?text=Blouse+Piece" },
    ],
    "Jewelry": [
      { name: "Beaded Earrings", unit: "bulk (50 sets)", marketPrice: 8000, wholesalePrice: 7000, img: "https://via.placeholder.com/80?text=Beaded+Earrings" },
      { name: "Clay Necklace", unit: "bulk (30 pcs)", marketPrice: 7500, wholesalePrice: 6500, img: "https://via.placeholder.com/80?text=Clay+Necklace" },
      { name: "Jhumka Earrings", unit: "bulk (40 sets)", marketPrice: 9000, wholesalePrice: 8000, img: "https://via.placeholder.com/80?text=Jhumka" },
      { name: "Rakhi Bracelet", unit: "bulk (100 sets)", marketPrice: 12000, wholesalePrice: 11000, img: "https://via.placeholder.com/80?text=Rakhi+Bracelet" },
      { name: "Silver Anklets", unit: "bulk (20 pairs)", marketPrice: 7000, wholesalePrice: 6000, img: "https://via.placeholder.com/80?text=Anklets" },
      { name: "Terracotta Bangles", unit: "bulk (50 sets)", marketPrice: 5000, wholesalePrice: 4500, img: "https://via.placeholder.com/80?text=Terracotta+Bangles" },
    ],
    "Candles": [
      { name: "Soy Candle", unit: "bulk box (50 pcs)", marketPrice: 10000, wholesalePrice: 9000, img: "https://via.placeholder.com/80?text=Soy+Candle" },
      { name: "Lavender Candle", unit: "bulk box (50 pcs)", marketPrice: 9000, wholesalePrice: 8000, img: "https://via.placeholder.com/80?text=Lavender+Candle" },
      { name: "Diya Candle", unit: "bulk box (100 pcs)", marketPrice: 12000, wholesalePrice: 11000, img: "https://via.placeholder.com/80?text=Diya+Candle" },
      { name: "Pine Candle", unit: "bulk box (50 pcs)", marketPrice: 11000, wholesalePrice: 10000, img: "https://via.placeholder.com/80?text=Pine+Candle" },
      { name: "Sandalwood Candle", unit: "bulk box (50 pcs)", marketPrice: 11500, wholesalePrice: 10500, img: "https://via.placeholder.com/80?text=Sandalwood" },
      { name: "Rose Candle", unit: "bulk box (50 pcs)", marketPrice: 10500, wholesalePrice: 9500, img: "https://via.placeholder.com/80?text=Rose+Candle" },
    ],
    "Pottery": [
      { name: "Clay Mug", unit: "bulk (50 pcs)", marketPrice: 12000, wholesalePrice: 11000, img: "https://via.placeholder.com/80?text=Clay+Mug" },
      { name: "Flower Pot", unit: "bulk (30 pcs)", marketPrice: 4500, wholesalePrice: 4000, img: "https://via.placeholder.com/80?text=Flower+Pot" },
      { name: "Rain Vase", unit: "bulk (20 pcs)", marketPrice: 4000, wholesalePrice: 3500, img: "https://via.placeholder.com/80?text=Rain+Vase" },
      { name: "Color Bowl", unit: "bulk (40 pcs)", marketPrice: 4800, wholesalePrice: 4200, img: "https://via.placeholder.com/80?text=Color+Bowl" },
      { name: "Terracotta Plate", unit: "bulk set (20 sets)", marketPrice: 6000, wholesalePrice: 5500, img: "https://via.placeholder.com/80?text=Terracotta+Plate" },
      { name: "Decorative Vase", unit: "bulk (15 pcs)", marketPrice: 7500, wholesalePrice: 7000, img: "https://via.placeholder.com/80?text=Decorative+Vase" },
    ],
    "Handicrafts": [
      { name: "Wooden Coasters", unit: "bulk (50 sets)", marketPrice: 8000, wholesalePrice: 7000, img: "https://via.placeholder.com/80?text=Wooden+Coasters" },
      { name: "Paper Mache Box", unit: "bulk (30 pcs)", marketPrice: 4500, wholesalePrice: 4000, img: "https://via.placeholder.com/80?text=Paper+Mache" },
      { name: "Bamboo Basket", unit: "bulk (20 pcs)", marketPrice: 5000, wholesalePrice: 4500, img: "https://via.placeholder.com/80?text=Bamboo+Basket" },
      { name: "Wall Hanging", unit: "bulk (15 pcs)", marketPrice: 6000, wholesalePrice: 5500, img: "https://via.placeholder.com/80?text=Wall+Hanging" },
      { name: "Macrame Plant Holder", unit: "bulk (25 pcs)", marketPrice: 5500, wholesalePrice: 5000, img: "https://via.placeholder.com/80?text=Macrame+Holder" },
      { name: "Quilled Greeting Cards", unit: "bulk (100 sets)", marketPrice: 12000, wholesalePrice: 11000, img: "https://via.placeholder.com/80?text=Quilled+Cards" },
      { name: "Clay Figurines", unit: "bulk (30 pcs)", marketPrice: 7500, wholesalePrice: 6500, img: "https://via.placeholder.com/80?text=Clay+Figurines" },
      { name: "Jute Bags", unit: "bulk (50 pcs)", marketPrice: 4000, wholesalePrice: 3500, img: "https://via.placeholder.com/80?text=Jute+Bags" },
    ],
  };

  const wholesaleOffers = [
    { name: "Mango Pickle", minQty: 10, newPrice: 600, unit: "bulk jar (5kg)", msg: "Buy 10+ bulk jars Mango Pickle @ ₹600 each!" },
    { name: "Lavender Soap", minQty: 5, newPrice: 3200, unit: "box (50 bars)", msg: "Buy 5+ boxes Lavender Soap @ ₹3200/box!" },
    { name: "Oatmeal Cookies", minQty: 20, newPrice: 1500, unit: "bulk pack (10 packs)", msg: "Buy 20+ bulk packs Oatmeal Cookies @ ₹1500 each!" },
    { name: "Herbal Tea", minQty: 10, newPrice: 3500, unit: "bulk pack (20 packs)", msg: "Buy 10+ bulk packs Herbal Tea @ ₹3500 each!" },
    { name: "Cotton Scarf", minQty: 50, newPrice: 5000, unit: "bulk (20 pcs)", msg: "Buy 50+ bulk Cotton Scarves @ ₹5000 each!" },
    { name: "Beaded Earrings", minQty: 20, newPrice: 6000, unit: "bulk (50 sets)", msg: "Buy 20+ bulk Beaded Earrings @ ₹6000 each!" },
    { name: "Clay Mug", minQty: 30, newPrice: 10000, unit: "bulk (50 pcs)", msg: "Buy 30+ bulk Clay Mugs @ ₹10000 each!" },
    { name: "Wooden Coasters", minQty: 40, newPrice: 6500, unit: "bulk (50 sets)", msg: "Buy 40+ bulk Wooden Coasters @ ₹6500 each!" },
  ];

  const handlePrepareBasket = () => {
    if (!selectedCategory) return alert("Select a category first!");
    if (!pinCode.trim() || !neighbourhood.trim()) return alert("Enter PIN Code and Neighbourhood!");
    setBasketItems(dummyItems[selectedCategory] || []);
    setBasketPrepared(true);
    setCart([]);
  };

  const handleAddToCart = (item) => {
    const existing = cart.find((c) => c.name === item.name);
    if (existing) {
      setCart(cart.map(c => c.name === item.name ? { ...c, qty: c.qty + 1 } : c));
    } else {
      setCart([...cart, { ...item, qty: 1 }]);
    }
  };

  const handleQtyChange = (itemName, delta) => {
    setCart(cart.map(c => {
      if (c.name === itemName) {
        const newQty = c.qty + delta;
        if (newQty <= 0) return null;
        return { ...c, qty: newQty };
      }
      return c;
    }).filter(Boolean));
  };

  const handleRemoveItem = (itemName) => setCart(cart.filter(c => c.name !== itemName));

  const getPrice = (item) => {
    const offer = wholesaleOffers.find(o => o.name === item.name && item.qty >= o.minQty);
    return offer ? offer.newPrice : item.wholesalePrice;
  };

  const handlePlaceOrder = () => {
    if (cart.length === 0) return alert("Add at least one item to cart!");
    setShowOrderForm(true);
  };

  const handleSubmitOrder = () => {
    const { name, address, pin, mobile, email } = orderDetails;
    if (!name || !address || !pin || !mobile || !email) return alert("Fill all order details!");
    setOrderPlaced(true);
    setShowOrderForm(false);
  };

  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Header */}
      <header className="bg-green-700 p-4 text-white flex flex-col md:flex-row md:items-center md:justify-between shadow-md">
        <h1 className="text-sm lg:text-xl font-bold mb-2 md:mb-0">MahilaMandi Wholesale: Bulk Orders for Retailers, Exporters & Markets</h1>
      </header>

      {/* Search Bar */}
      <div className="flex flex-row justify-between p-4 bg-black border border-green-500 shadow-sm">
        <div className="flex items-start space-x-2 text-white">
          <FontAwesomeIcon className="mt-2" icon={faMapMarkerAlt} />
          <input
            type="text"
            value={pinCode}
            onChange={(e) => setPinCode(e.target.value)}
            placeholder="Enter PIN Code"
            className="px-2 py-1 rounded text-black w-40 md:w-40"
          />
        </div>
        <div className="flex w-full items-start bg-black border border-green-500 p-2 rounded-lg">
          <FontAwesomeIcon icon={faSearch} className="text-green-600" />
          <input
            type="text"
            value={neighbourhood}
            onChange={(e) => setNeighbourhood(e.target.value)}
            placeholder="Search neighbourhood or product"
            className="ml-2 bg-transparent outline-none flex-1"
          />
        </div>
      </div>

      {/* Categories Grid */}
      <div className="p-4 grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {categories.map((cat) => (
          <div
            key={cat.name}
            onClick={() => setSelectedCategory(cat.name)}
            className={`flex flex-col items-center bg-white rounded-xl shadow p-4 cursor-pointer hover:scale-105 transition transform ${
              selectedCategory === cat.name ? "border-2 border-green-700" : ""
            }`}
          >
            <div className="text-4xl mb-2">{cat.img}</div>
            <span className="text-xs font-medium text-center">{cat.name}</span>
          </div>
        ))}
      </div>

      {/* Prepare Basket Button */}
      <div className="p-4">
        <button
          onClick={handlePrepareBasket}
          className="w-56 bg-green-600 border border-green-500 text-white py-2 rounded-lg hover:bg-green-800 flex items-center justify-center space-x-2"
        >
          Prepare Wholesale Basket
        </button>
      </div>

      {/* Basket Items */}
      {basketPrepared && (
        <>
          <div className="p-4 bg-black border border-green-500 text-white rounded shadow mb-4">
            <h3 className="text-yellow-200 text-lg lg:text-xl font-bold">📦 Wholesale Offers 📦</h3>
            <ul className="list-disc pl-5">
              {wholesaleOffers.map((offer) => (
                <li key={offer.name}>{offer.msg}</li>
              ))}
            </ul>
          </div>

          <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {basketItems.map((item) => (
              <div key={item.name} className="bg-black text-white border border-green-500 p-4 rounded shadow flex flex-col items-center">
                <img src={item.img} alt={item.name} className="w-20 h-20 object-cover mb-2 rounded" />
                <span className="font-medium text-white">{item.name} ({item.unit})</span>
                <span className="line-through text-sm text-white">₹{item.marketPrice}/{item.unit}</span>
                <span className="text-white font-bold">₹{item.wholesalePrice}/{item.unit}</span>
                <button
                  onClick={() => handleAddToCart(item)}
                  className="mt-2 w-24 bg-black border border-green-500 text-white py-1 px-3 rounded hover:bg-green-700"
                >
                  Add
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Cart & Place Order */}
      {basketPrepared && (
        <div className="p-4">
          <h3 className="text-yellow-200 text-lg lg:text-xl font-bold mb-2">Cart</h3>
          {cart.length === 0 ? (
            <p>No items added yet.</p>
          ) : (
            <div className="space-y-2">
              {cart.map((c) => (
                <div key={c.name} className="flex justify-between bg-black text-white border border-green-500 p-2 rounded shadow items-center">
                  <div className="flex items-center gap-2">
                    <img src={c.img} alt={c.name} className="w-10 h-10 object-cover rounded" />
                    <span>{c.name} ({c.unit})</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleQtyChange(c.name, -1)}
                      className="bg-green-700 text-white px-2 w-8 rounded hover:bg-green-800"
                    >
                      -
                    </button>
                    <span>{c.qty}</span>
                    <button
                      onClick={() => handleQtyChange(c.name, +1)}
                      className="bg-blue-700 text-white px-2 w-8 rounded hover:bg-green-800"
                    >
                      +
                    </button>
                    <span>₹{getPrice(c) * c.qty}</span>
                    <button
                      onClick={() => handleRemoveItem(c.name)}
                      className="bg-red-600 text-white px-2 w-8 rounded hover:bg-red-700"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
          <button
            onClick={handlePlaceOrder}
            className="mt-4 w-full bg-green-600 border border-green-500 text-white py-2 rounded-lg flex items-center justify-center space-x-2 hover:bg-green-800"
          >
            <FontAwesomeIcon icon={faTruck} />
            <span>Place Wholesale Order</span>
          </button>
        </div>
      )}

      {/* Order Form */}
      {showOrderForm && (
        <div className="p-4 bg-black border border-green-500 text-white shadow rounded m-4">
          <h3 className="font-bold mb-2">Enter Delivery Details</h3>
          <div className="flex flex-col py-2 px-2 gap-2">
            {"name address pin mobile email".split(" ").map((field) => (
              <input
                key={field}
                type="text"
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={orderDetails[field]}
                onChange={e => setOrderDetails({ ...orderDetails, [field]: e.target.value })}
                className="p-2 border rounded"
              />
            ))}
          </div>
          <button
            onClick={handleSubmitOrder}
            className="mt-4 w-64 bg-green-600 border border-green-500 text-white py-2 rounded hover:bg-green-800"
          >
            Confirm Wholesale Order
          </button>
        </div>
      )}

      {/* Invoice */}
      {orderPlaced && (
        <div className="p-4 bg-black text-white border border-green-500 shadow rounded m-4">
          <h3 className="text-yellow-200 text-xl font-bold mb-2">Wholesale Order Placed Successfully!</h3>
          <h3 className="text-white font-bold mb-2">Delivery scheduled as per logistics.</h3>
          <p>Invoice:</p>
          <ul className="list-disc pl-5">
            {cart.map((c) => (
              <li key={c.name}>{c.name} ({c.unit}) x {c.qty} = ₹{getPrice(c) * c.qty}</li>
            ))}
          </ul>
          <p className="font-bold">Total: ₹{cart.reduce((a, b) => a + getPrice(b) * b.qty, 0)}</p>
        </div>
      )}

      {/* Footer */}
      <footer className="mt-auto bg-green-800 text-white text-center p-4 text-sm">
        © 2025 MahilaMandi Wholesale by Think5Whys
      </footer>
    </div>
  );
}